import { Stack, Typography } from '@mui/material';
import { IEntitlement } from 'API/compassRights';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { AdditionalTerms } from './AdditionalTerms';
import { EntitlementConditions } from './EntitlementConditions';
import { EntitlementLinks } from './EntitlementLinks';
import { GeneralData } from './GeneralData';
import { LastDateUse } from './LastDateUse';
import { UpToDate } from './UpToDate';

interface IEntitlementData {
  userEntitlement: IEntitlement;
}

export const EntitlementData = ({ userEntitlement }: IEntitlementData) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.CompassRights);

  return (
    <Stack
      bgcolor={'#fff'}
      direction='column'
      boxShadow='0px 2px 16px 0px rgba(8, 30, 84, 0.08)'
      borderRadius={'16px'}
      border={'1px solid'}
      borderColor={'primary.shade_100'}
      padding={isDesktop ? '40px 40px 56px 40px' : '20px 20px 40px 20px'}
      gap='10px'
      margin='0 0 60px 0'
      aria-label={Dictionary[DICTIONARY.CompassRights].entitlements.generalInfo}
    >
      <Stack maxWidth={isDesktop ? '772px' : 'initial'}>
        <Typography
          variant={'body1'}
          color={'text.secondary'}
          marginBottom={'4px'}
        >
          {dictionary.rightsExplained}
        </Typography>

        {userEntitlement?.lastDateTimeUsed && (
          <LastDateUse lastDateUse={userEntitlement?.lastDateTimeUsed} />
        )}
        {userEntitlement?.eligibleFrequency && (
          <UpToDate eligibleFrequency={userEntitlement?.eligibleFrequency} />
        )}
        <GeneralData generalData={userEntitlement?.description} />
        <EntitlementLinks
          instruction={userEntitlement?.instruction}
          activation={userEntitlement?.activation}
        />
        {userEntitlement?.critereaDesc?.length > 0 && (
          <EntitlementConditions conditions={userEntitlement?.critereaDesc} />
        )}
        {userEntitlement?.OtherCriteriaUrl && (
          <AdditionalTerms pdf={userEntitlement?.OtherCriteriaUrl} />
        )}
        {userEntitlement?.contact && (
          <Typography variant={'body4'} component='h2'>
            {Dictionary[DICTIONARY.CompassRights].entitlements.contact('')}
            {userEntitlement?.contact}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};
